import { useTranslations } from "next-intl";
import React from "react";

function Highlighter({
  iKey,
  color,
  variant = "underLine",
}: HighlighterProps) {
  const colorStyle = {
    color: color,
  };
  const underLineStyle = {
    borderColor: color,
    borderStyle: "solid",
    borderBottomWidth: "3px",
  };
  const bgStyle = {
    background: color,

  };
  const t = useTranslations("");

  return (
    <>
      {" "}
      {t.rich(iKey, {
        important: (chunks) => (
          <span style={variant == "underLine" ?underLineStyle: variant == 'bg' ? bgStyle  : colorStyle}>
            {chunks}
          </span>
        ),
      })}
    </>
  );
}

export default Highlighter;
type HighlighterProps = {
  iKey: string;
  variant?: "underLine" | "color" | "bg";
  color?: string;
};
